import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddTenantIdProperty1696935422994 implements MigrationInterface {
	name = 'AddTenantIdProperty1696935422994'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "menu_item" ADD "tenantId" uuid`)
		await queryRunner.query(`ALTER TABLE "menu_item_category" ADD "tenantId" uuid`)
		await queryRunner.query(`ALTER TABLE "category" ADD "tenantId" uuid`)
		await queryRunner.query(`ALTER TABLE "user_credentials" ADD "tenantId" uuid`)
		await queryRunner.query(`ALTER TABLE "user" ADD "tenantId" uuid`)
		await queryRunner.query(`ALTER TABLE "table" ADD "tenantId" uuid`)
		await queryRunner.query(`ALTER TABLE "table_subscriber" ADD "tenantId" uuid`)
		await queryRunner.query(`ALTER TABLE "company" ADD "tenantId" uuid`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "company" DROP COLUMN "tenantId"`)
		await queryRunner.query(`ALTER TABLE "table_subscriber" DROP COLUMN "tenantId"`)
		await queryRunner.query(`ALTER TABLE "table" DROP COLUMN "tenantId"`)
		await queryRunner.query(`ALTER TABLE "user" DROP COLUMN "tenantId"`)
		await queryRunner.query(`ALTER TABLE "user_credentials" DROP COLUMN "tenantId"`)
		await queryRunner.query(`ALTER TABLE "category" DROP COLUMN "tenantId"`)
		await queryRunner.query(`ALTER TABLE "menu_item_category" DROP COLUMN "tenantId"`)
		await queryRunner.query(`ALTER TABLE "menu_item" DROP COLUMN "tenantId"`)
	}
}
